<template>
  <div class="animated fadeIn">
    <div class="row">
      <div class="col-12 pt-3 pb-3 pl-4">
        <h3><i class="fas fa-user-tie"></i> Funcionário</h3>
      </div>
    </div>
    <employeeAdd v-if="showAdd" ref="employeeAdd" v-on:Back="onBack" />
    <employeeList v-else ref="employeeList" v-on:New="onNew" v-on:Edit="onEdit"/>
  </div>
</template>
<script>
import Tools from '@/components/tools/Tools.js'
import employeeAdd from './components/add/employeeAdd.vue'
import employeeList from './components/list/employeeList.vue'

export default {
  name: 'Employee',
  data () {
    return {
      showAdd: false
    }
  },
  components: {
    employeeAdd,
    employeeList
  },
  mounted () {
    // Tools.MinimizedSidebar()
  },
  beforeDestroy () {
    this.$eventHub.off('Filter')
    Tools.MinimizedASidebar()
  },
  methods: {
    onLoad () {},
    onNew () {
      this.showAdd = true
    },
    onEdit (obj) {
      this.showAdd = true
      this.$nextTick(() => {
        this.$refs.employeeAdd.onEdit(obj)
      })
    },
    onBack () {
      this.showAdd = false
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/private/configurations/employee/employee.vue